export type surveyDataType = {
  question: string;
  answers: string[];
};
export const surveyData = {
  '1': {
    question: 'Как часто воспитатели вашего муниципалитета применяют цифровые инструменты в работе?',
    answers: ['Часто', 'Не очень часто', 'Не применяют'],
  },
  '2': {
    question:
      'Важно ли вам, чтобы воспитатели муниципалитета получили доступ к диагностике Учи.ру, которая позволяет проверить, насколько дети готовы к школе?',
    answers: ['Да', 'Нет'],
  },
  '3': {
    question: 'Важно ли вам, чтобы воспитатели муниципалитета получили доступ к игровым заданиям Учи.ру?',
    answers: ['Да', 'Нет'],
  },
  '4': {
    question:
      'Важно ли вам, чтобы воспитатели муниципалитета получили доступ к вебинарам, конференциям и курсам повышения квалификации Учи.ру?',
    answers: ['Да', 'Нет'],
  },
  '5': {
    question:
      'Вы бы хотели сотрудничать с Учи.ру, чтобы вместе реализовать в муниципалитете проект «Вектор роста» для дошкольных образовательных учреждений?',
    answers: ['Да', 'Нет'],
  },
  '6': {
    question:
      'Какое направление проекта «Вектор роста» вы считаете наиболее приоритетным для дошкольных образовательных учреждений муниципалитета?',
    answers: [
      'Цифровые инструменты для работы с дошкольниками',
      'Мероприятия для профессионального развития воспитателей',
      'Оба направления',
      'Ни одно из направлений',
    ],
  },
  '7': { question: 'Ваше имя' },
  '8': { question: 'Должность' },
  '9': { question: 'Email' },
  '10': { question: 'Телефон' },
};
